<template>
  <app-loader-section v-if="loading" whole-height />
  <div v-else-if="page" role="main" container>
    <router-link
      :to="{ path: localizedRoute, query: { search: $route.query.search } }"
      class="inline-caret-link reverse hide-print _ms" style="display: inline-block;font-size: 1.1rem; font-weight: bold;"
      :style="globalTheme.colorPrimary"
    >
      <font-awesome-icon :icon="['fas', 'caret-left']" class="caret _mrxxs" />
      {{ page?.backToResultsLabel }}
    </router-link>

    <search-result-card 
      :provider="provider" 
      :labels="page" 
      :special-offers="page.specialOffers" 
      :view-details="true" 
      :doctor-details="page.doctorDetails" 
      :legacy-network="legacyNetwork"
      :offer-button-label="page.offerButtonLabel"
      :offer-popup-independent="page.offerPopupIndependent"
      :hide-accept-new-patient="page.hideAcceptNewPatient"
      />

  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { LocationDetailsPageLabels } from "@/types";
import { locationDetailsPageLabelsFactory } from "@/factories/contentstack/location-details-page-labels.factory";
import GetPage from "@/mixins/GetPage";
import { mapState, mapGetters } from 'vuex'
import SearchResultCard from '../components/organisms/Results/SearchResultCard.vue';
import { getBaseUrl } from "@/site.config.ts";

const name = "details";
export default defineComponent({
  name: name,
  mixins: [GetPage],
  components: {
    SearchResultCard,
  },
  data(){
    return {
      page: null as LocationDetailsPageLabels | null,
    }
  },
  computed: {
    ...mapState('currentProvider', {
      provider: (state: any) => state.currentProvider
    }),
    ...mapGetters('context', ['legacyNetwork']),
    localizedRoute() {
      return `${getBaseUrl(this.$route.params)}/results`;
    },
    selectedLanguage(): any {
      return this.$store.state.locale.languageSelect
    },
  },
  watch:{
     selectedLanguage: {
        handler(languageSelect) {
       setTimeout(() => {
        window.location.reload()
       }, 100)
      },
        deep: true
      },
  },
  async created(): Promise<void> {
    await (this as any).getStackPageByName(
      name,
      locationDetailsPageLabelsFactory as (
        page: any
      ) => LocationDetailsPageLabels
    );
    if (!this.page) {
      this.loading = false;
      return;
    }
    this.page = {
      ...this.page,
      specialOffers:this.$store.state.context.specialOffers,
    };
    this.emitResizeEvent()
  },
});
</script>
